import { getConfigManager } from '../../config';
import { createAsyncAtom } from '../../lib/state';

const nostraTokenListAtom = createAsyncAtom(async () => getConfigManager().getNostraTokenList());

export default nostraTokenListAtom;
